module.exports = __webpack_public_path__ + "img/6e7c6f3124341aa94e5615a5d91707ba.85c8e22b.jpg";